import { LocationFilterValue } from './PassesFilterContext';

export const UNDETERMINED_LOCATION_SENTINEL = '__undetermined__';

export const toSentinel = (v: LocationFilterValue): string => (v === null ? UNDETERMINED_LOCATION_SENTINEL : v);
export const fromSentinel = (s: string): LocationFilterValue => (s === UNDETERMINED_LOCATION_SENTINEL ? null : s);
